import { useState } from "react";

import useResizeObserver2 from "./useResizeObserver2";

/**
 * @param {import("react").Ref} ref
 * @returns {number}
 */
const useWidth = (ref) => {
  // Lazy on purpose: as a plain argument this read ran on every render and
  // forced a style + layout pass React then threw away (mount is the only
  // render that uses it). Reading clientWidth once at mount is fine.
  const [width, setWidth] = useState(() => ref.current?.clientWidth || 0);

  useResizeObserver2(ref, () => {
    setWidth(ref.current?.clientWidth || 0);
  });

  return width;
};

export default useWidth;
